import CaptureButtonComponent from "./CaptureButtonComponent";

export default CaptureButtonComponent;